export default "__VITE_ASSET__BvG05UMT__"